/* Neeta Lulla — cart drawer activation (sitewide; loaded from sections/nl-header.liquid).
   The NL header is a custom section, so the base theme never starts its own cart drawer. This file:
   1) starts theme.CartDrawer (the base theme's drawer: #CartDrawer markup is rendered by nl-header.liquid);
   2) opens it whenever an item is added from ANY page — NL product page, collection quick-add, etc. —
      by announcing the same 'ajaxProduct:added' event the base theme's own add-to-cart uses.
   The Bag icon in the header carries .js-drawer-open-cart, so clicking it opens the drawer too. */
(function () {
  'use strict';

  function startDrawer() {
    if (window.nlCartDrawerStarted) return;
    if (!document.getElementById('CartDrawer')) return;
    if (!window.theme || !theme.CartDrawer || !theme.settings || theme.settings.cartType !== 'drawer') return;
    if (document.body.classList.contains('template-cart')) return;
    window.nlCartDrawerStarted = true;
    try { new theme.CartDrawer(); } catch (e) { window.nlCartDrawerStarted = false; }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startDrawer);
  else startDrawer();

  /* Announce successful add-to-cart calls made by NL scripts (they use fetch('/cart/add.js') directly).
     Requests that carry X-Requested-With are the base theme's own add-to-cart, which already announces itself. */
  if (window.fetch && !window.nlCartFetchPatched) {
    window.nlCartFetchPatched = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var promise = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : ((input && input.url) || '');
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        var headers = (init && init.headers) || (input && input.headers) || {};
        var xrw = headers && (typeof headers.get === 'function' ? headers.get('X-Requested-With') : headers['X-Requested-With']);
        if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && !xrw) {
          promise.then(function (res) {
            if (res && res.ok) {
              setTimeout(function () { document.dispatchEvent(new CustomEvent('ajaxProduct:added')); }, 0);
            }
          }).catch(function () {});
        }
      } catch (e) { /* never break the add-to-cart itself */ }
      return promise;
    };
  }
})();